var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManagers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2171",
    d: "M14,2a6,6,0,1,0,6,6A6.015,6.015,0,0,0,14,2Zm0,2a4,4,0,1,1-4,4A3.985,3.985,0,0,1,14,4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2173",
    d: "M11,16a9,9,0,0,0-9,9v2a1,1,0,0,0,1,1H13.848a1,1,0,1,0,0-2H4V25a6.963,6.963,0,0,1,7-7h4.016a1,1,0,1,0,0-2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2175",
    d: "M22.987,16A1,1,0,0,0,22,17.014V18.1a4.977,4.977,0,0,0-1.754.736l-.768-.768a.968.968,0,0,0-.756-.32,1.01,1.01,0,0,0-.658,1.734l.771.771A4.975,4.975,0,0,0,18.1,22.01H17.014a1,1,0,1,0,0,2H18.1a4.977,4.977,0,0,0,.73,1.738l-.777.777a1,1,0,1,0,1.414,1.414l.775-.775A4.977,4.977,0,0,0,22,27.9v1.088a1,1,0,1,0,2,0V27.9a4.974,4.974,0,0,0,1.748-.732l.781.781a1,1,0,1,0,1.414-1.414l-.777-.777A4.976,4.976,0,0,0,27.9,24.01h1.09a1,1,0,1,0,0-2H27.9a4.976,4.976,0,0,0-.736-1.764l.771-.771a1,1,0,1,0-1.41-1.414l-.774.773A4.974,4.974,0,0,0,24,18.1V17.014A1,1,0,0,0,22.99,16ZM23,20a3,3,0,1,1-3,3A2.985,2.985,0,0,1,23,20Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagers);
export default __webpack_public_path__ + "static/media/managers.549b93ed0afd6e2f92b048db6546b39a.svg";
export { ForwardRef as ReactComponent };